/**
 * Created by yanxiaojun on 2017/4/13.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class GlobalData {

  private _loginTargetPage: string;//用户id
  private _loginTargetPageParams: any;//用户名
  private _token: string;//token
  private _showLoading: boolean = true;//请求是否显示loading,注意:设置为true,当请求执行后需要设置为false

  private _festival: any[];//token
  private _isLogin:boolean;
  private _updateUrl:string;


  get isLogin():boolean{
    return this._isLogin;
  }

  set isLogin(value:boolean){
    this._isLogin=value;
  }

  


  get loginTargetPage(): string {
    return this._loginTargetPage;
  }

  set loginTargetPage(value: string) {
    this._loginTargetPage = value;
  }

  get loginTargetPageParams(): any {
    return this._loginTargetPageParams;
  }

  set loginTargetPageParams(value: any) {
    this._loginTargetPageParams = value;
  }

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get updateUrl(): string {
    return this._updateUrl;
  }

  set updateUrl(value: string) {
    this._updateUrl = value;
  }


  get festival(): any[] {
    return this._festival;
  }

  set festival(value: any[]) {
    this._festival = value;
  }


  get showLoading(): boolean {
    return this._showLoading;
  }

  set showLoading(value: boolean) {
    this._showLoading = value;
  }
}


// WEBPACK FOOTER //
// ./src/providers/GlobalData.ts